import { render, staticRenderFns } from "./diyPoster.vue?vue&type=template&id=3f5807f0&scoped=true&"
import script from "./diyPoster.vue?vue&type=script&lang=js&"
export * from "./diyPoster.vue?vue&type=script&lang=js&"
import style0 from "./diyPoster.vue?vue&type=style&index=0&id=3f5807f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5807f0",
  null
  
)

export default component.exports